var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "top-nav" } }, [
    _c("div", { staticClass: "header-container" }, [
      _c("div", { staticClass: "header-left" }, [
        _vm.isCollapse
          ? _c("img", {
              staticClass: "fold-btn",
              attrs: {
                src: "https://s3.ap-malaysia-1.jdcloud-oss.com/jd-th-055-01-fop-source-static/iwms/el-icon-s-unfold.png",
                alt: "",
                clstag: "h|keycount|topMenu|toggleCollapse",
              },
              on: { click: _vm.toggleCollapse },
            })
          : _c("img", {
              staticClass: "fold-btn",
              attrs: {
                src: "https://s3.ap-malaysia-1.jdcloud-oss.com/jd-th-055-01-fop-source-static/iwms/el-icon-s-fold.png",
                alt: "",
                clstag: "h|keycount|topMenu|toggleCollapse",
              },
              on: { click: _vm.toggleCollapse },
            }),
        _c("img", {
          staticClass: "iwms-logo en-logo",
          attrs: {
            src: "https://s3.ap-malaysia-1.jdcloud-oss.com/jd-th-055-01-fop-source-static/iwms/LOGO-iWMS-e.png",
            alt: "",
          },
        }),
      ]),
      _c("i", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isScroll,
            expression: "isScroll",
          },
        ],
        staticClass: "el-icon-arrow-left",
        attrs: { clstag: "h|keycount|topMenu|leftSlide" },
        on: { click: _vm.leftSlide },
      }),
      _c(
        "div",
        { ref: "wrapperCon", staticClass: "header-center" },
        _vm._l(_vm.menuTree, function (menu) {
          return _c(
            "div",
            {
              key: menu.id,
              staticClass: "top-menu-item",
              class: { "menu-active": _vm.topIndex === menu.topIndex },
              attrs: { clstag: _vm.getTopMenuClstag(menu) },
              on: {
                click: function ($event) {
                  return _vm.handleSelectTopMenu(menu)
                },
              },
            },
            [
              menu.code !== "globalBtnPermission"
                ? [
                    _c(
                      "ToolTips",
                      {
                        staticStyle: { "text-align": "center" },
                        attrs: {
                          effect: "dark",
                          text: menu.translation
                            ? _vm.$t(menu.translation)
                            : menu.name,
                          placement: "bottom",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              menu.translation
                                ? _vm.$t(menu.translation)
                                : menu.name
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          )
        }),
        0
      ),
      _c("i", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isScroll,
            expression: "isScroll",
          },
        ],
        staticClass: "el-icon-arrow-right",
        attrs: { clstag: "h|keycount|topMenu|rightSlide" },
        on: { click: _vm.rightSlide },
      }),
      _c(
        "div",
        { staticClass: "header-right" },
        [
          _vm.showTogglePlatform
            ? _c(
                "div",
                { staticClass: "platformBtn" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        round: "",
                        clstag: "h|keycount|topMenu|toPlatform",
                      },
                      on: { click: _vm.toPlatform },
                    },
                    [
                      _c("i", { staticClass: "i-toggle" }),
                      _vm._v(" " + _vm._s(_vm.$t("adminDashboard")) + " "),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-popover",
            {
              attrs: {
                placement: "bottom",
                width: "280",
                "visible-arrow": false,
                "popper-class": "top-nav-package-popper",
                trigger: "hover",
              },
            },
            [
              _c("div", { staticClass: "title" }, [
                _c("img", {
                  attrs: {
                    src: require("@/assets/images/newMenus/doc.png"),
                    alt: "",
                  },
                }),
                _vm._v(_vm._s(_vm.$t("submitInfo")) + " "),
              ]),
              _c("div", { staticClass: "op-list" }, [
                _c(
                  "div",
                  {
                    staticClass: "op-item",
                    attrs: { clstag: "h|keycount|topMenu|openWorkOrder" },
                    on: { click: _vm.openWorkOrder },
                  },
                  [_vm._v(_vm._s(_vm.$t("itWorkOrder")))]
                ),
              ]),
              _c("div", { staticClass: "title" }, [
                _c("img", {
                  attrs: {
                    src: require("@/assets/images/newMenus/robot.png"),
                    alt: "",
                  },
                }),
                _vm._v(_vm._s(_vm.$t("warehouseRobot")) + " "),
              ]),
              _c("div", { staticClass: "op-list" }, [
                _c(
                  "div",
                  {
                    staticClass: "op-item",
                    attrs: { clstag: "h|keycount|topMenu|openRobot" },
                    on: {
                      click: function ($event) {
                        return _vm.openRobot("app.upnjdfhh")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("warehouseRobot")))]
                ),
              ]),
              _c("div", { staticClass: "title" }, [
                _c("img", {
                  attrs: {
                    src: require("@/assets/images/newMenus/chat.png"),
                    alt: "",
                  },
                }),
                _vm._v(_vm._s(_vm.$t("contactUs")) + " "),
              ]),
              _c(
                "ul",
                { staticClass: "contact-list" },
                _vm._l(_vm.contactList, function (item) {
                  return _c(
                    "li",
                    { key: item.value, staticClass: "list-item" },
                    [
                      _c("span", { staticClass: "label" }, [
                        _vm._v(_vm._s(_vm.$t(item.label)) + ": "),
                      ]),
                      _c(
                        "span",
                        {
                          staticClass: "value",
                          attrs: { clstag: "h|keycount|topMenu|openDongDong" },
                          on: {
                            click: function ($event) {
                              return _vm.openDongDong(item.value, "2")
                            },
                          },
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/images/newMenus/dongdong.png"),
                              alt: "",
                            },
                          }),
                          _vm._v(_vm._s(item.value)),
                        ]
                      ),
                    ]
                  )
                }),
                0
              ),
              _c("img", {
                staticClass: "package-icon",
                attrs: {
                  slot: "reference",
                  src: require("@/assets/images/newMenus/package.png"),
                  alt: "",
                },
                slot: "reference",
              }),
            ]
          ),
          _c(
            "el-popover",
            {
              attrs: {
                placement: "bottom",
                width: "400",
                "visible-arrow": false,
                "popper-class": "top-nav-download-popper",
                trigger: "hover",
              },
            },
            [
              _c("p", { staticClass: "bottom-text" }, [
                _c("img", {
                  attrs: {
                    src: require("@/assets/images/newMenus/doc.png"),
                    alt: "",
                  },
                }),
                _c("span", [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("downloadAndroidTitle"))),
                  ]),
                ]),
              ]),
              _c(
                "p",
                {
                  staticClass: "bottom-text",
                  staticStyle: {
                    "padding-top": "0",
                    display: "inline-block",
                    "text-align": "left",
                  },
                },
                [
                  _vm._v(" " + _vm._s(_vm.$t("downloadAppTips1"))),
                  _c(
                    "span",
                    {
                      staticClass: "color-blue",
                      attrs: {
                        clstag: "h|keycount|topMenu|openRobotFromDownload",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.openRobot("app.upnjdfhh")
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("downloadAppTips2")))]
                  ),
                ]
              ),
              _c("div", { staticClass: "qrcode-container" }, [
                _c("img", { attrs: { src: _vm.downloadImg, alt: "" } }),
              ]),
              _c("div", { staticClass: "other-wrap" }, [
                _c("p", { staticClass: "title-wrap" }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/newMenus/doc.png"),
                      alt: "",
                    },
                  }),
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("otherDownload"))),
                  ]),
                ]),
                _c("div", { staticClass: "other-content" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("cloudPrintingAssistant")) + "："),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://s3.ap-malaysia-1.jdcloud-oss.com/jd-th-053-01-imp/PrintAgent-EN-2.1.1.4.exe",
                        target: "_blank",
                        rel: "noopener noreferrer",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("clickDownload")))]
                  ),
                ]),
              ]),
              _vm.site
                ? _c("img", {
                    staticClass: "download-icon",
                    attrs: {
                      slot: "reference",
                      src: require("@/assets/images/newMenus/download.png"),
                      alt: "",
                    },
                    slot: "reference",
                  })
                : _vm._e(),
            ]
          ),
          _vm.isErpLogin
            ? _c("msg-box", {
                attrs: {
                  userNo: _vm.userInfo.userCode,
                  channel: "iWMS",
                  boxPosition: { top: 50, right: -40 },
                },
              })
            : _vm._e(),
          _c(
            "el-dropdown",
            {
              attrs: { size: "small" },
              on: { command: _vm.handleCommandLang },
            },
            [
              _c("span", { staticClass: "el-dropdown-link" }, [
                _c("div", { staticClass: "el-dropdown-user" }, [
                  _c("span", [_vm._v(_vm._s(_vm.langMaps[_vm.$i18n.locale]))]),
                  _c("i", { staticClass: "el-icon-arrow-down el-icon--right" }),
                ]),
              ]),
              _c(
                "el-dropdown-menu",
                {
                  staticClass: "lang-dropdown",
                  attrs: { slot: "dropdown" },
                  slot: "dropdown",
                },
                _vm._l(_vm.langMaps, function (lang, key) {
                  return _c(
                    "el-dropdown-item",
                    {
                      key: lang,
                      class: { "current-lang": _vm.$i18n.locale === key },
                      attrs: { command: key, clstag: _vm.langClick(key) },
                    },
                    [_vm._v(_vm._s(lang))]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm.isJDDomain
            ? _c(
                "el-dropdown",
                {
                  staticClass: "dropdown-box jdc-container",
                  on: { command: _vm.changeSite },
                },
                [
                  _c("span", { staticClass: "el-dropdown-link" }, [
                    _c("span", { staticClass: "el-dropdown-link" }, [
                      _c("div", { staticClass: "el-dropdown-user" }, [
                        _c("span", [_vm._v(_vm._s(_vm.siteName))]),
                        _c("i", {
                          staticClass: "el-icon-arrow-down el-icon--right",
                        }),
                      ]),
                    ]),
                  ]),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c(
                        "el-dropdown-item",
                        {
                          attrs: {
                            command: "SG",
                            clstag: "h|keycount|topMenu|changeSite|SG",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("siteMapSG")))]
                      ),
                      _c(
                        "el-dropdown-item",
                        {
                          attrs: {
                            command: "EU",
                            clstag: "h|keycount|topMenu|changeSite|EU",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("siteMapEU")))]
                      ),
                      _c(
                        "el-dropdown-item",
                        {
                          attrs: {
                            command: "US",
                            clstag: "h|keycount|topMenu|changeSite|US",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("siteMapUS")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-dropdown",
            { attrs: { size: "small" }, on: { command: _vm.handleCommand } },
            [
              _c("span", { staticClass: "el-dropdown-link" }, [
                _c("div", { staticClass: "el-dropdown-user" }, [
                  _c("img", {
                    staticClass: "dropdown-avatar",
                    attrs: {
                      src: require("@/assets/images/default_avatar.png"),
                      alt: "photo",
                    },
                  }),
                  _c("i", { staticClass: "el-icon-arrow-down" }),
                ]),
              ]),
              _c(
                "el-dropdown-menu",
                {
                  staticClass: "user-dropdown",
                  attrs: { slot: "dropdown" },
                  slot: "dropdown",
                },
                [
                  _c("p", { staticClass: "user-name" }, [
                    _vm._v("Hi, "),
                    _c("span", [_vm._v(_vm._s(_vm.userInfo.userName))]),
                  ]),
                  _c(
                    "el-dropdown-item",
                    {
                      attrs: {
                        command: "copyUserCode",
                        icon: "el-icon-document-copy",
                        clstag: "h|keycount|topMenu|copyUserCode",
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.userInfo.userCode) + " ")]
                  ),
                  _c(
                    "el-dropdown-item",
                    {
                      attrs: {
                        command: "selectWearhouse",
                        icon: "el-icon-house",
                        clstag: "h|keycount|topMenu|selectWarehouse",
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.currentWarehouse) + " ")]
                  ),
                  _vm.hasOnlineCorrectionPermission
                    ? _c(
                        "el-dropdown-item",
                        {
                          attrs: {
                            command: "switchDebug",
                            icon: "el-icon-edit",
                            clstag: "h|keycount|topMenu|switchDebug",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.debugIsOn
                                  ? _vm.$t("关闭在线纠错")
                                  : _vm.$t("开启在线纠错")
                              ) +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c("div", { staticClass: "divider" }),
                  _c(
                    "el-dropdown-item",
                    {
                      attrs: {
                        command: "logout",
                        icon: "el-icon-switch-button",
                        clstag: "h|keycount|topMenu|logout",
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("signOut")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { attrs: { id: "lang-box" } }),
    ]),
    _vm._m(0),
    _c("canvas", {
      ref: "canvasCountry",
      staticStyle: { visibility: "hidden" },
      attrs: { width: "500", height: "200", id: "canvasCountry" },
    }),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticStyle: { visibility: "hidden" },
        attrs: { id: "barcodeWrapper" },
      },
      [_c("img", { attrs: { id: "barcode" } })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }